import React, { forwardRef } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Props {
  selectedCount: number;
  onSubmit: () => void;
  onCancel: () => void;
}

export const SummaryActionBar = forwardRef<HTMLDivElement, Props>(
  function SummaryActionBar(
    { selectedCount, onSubmit, onCancel },
    ref
  ): React.ReactElement {
    const theme = useTheme();

    return (
      <Box
        ref={ref}
        role="toolbar"
        aria-label="Selection actions"
        sx={{
          position: 'sticky',
          bottom: 0,
          bgcolor: 'background.paper',
          borderTop: `1px solid ${theme.palette.divider}`,
          p: 2,
          pt: 1.5,
          pb: 2.5,
          zIndex: 10,
        }}
      >
        <Stack spacing={1.25} flexDirection="row" alignItems="stretch" gap={1}>
          <Button
            variant="contained"
            fullWidth
            disabled={selectedCount === 0}
            onClick={onSubmit}
            sx={{
              order: 1,
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              p: 1.25,
              flex: 1,
              fontSize: 16,
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': { bgcolor: 'primary.dark' },
              boxShadow: 'none',
              '&.Mui-disabled': {
                bgcolor: 'action.disabledBackground',
                color: 'action.disabled',
              },
            }}
          >
            Answer these questions again
          </Button>
          <Button
            variant="outlined"
            onClick={onCancel}
            color="grey"
            sx={{
              color: 'text.secondary',
              flex: '0 0 auto',
              px: 5,
              fontSize: 16,
              m: '0 !important',
              fontWeight: 600,
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    );
  }
);
